/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexDto } from '../../models/backend-capex-dto';

export interface CapexsCopyCreate$Params {
  id: number;
}

export function capexsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: CapexsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexDto>> {
  const rb = new RequestBuilder(rootUrl, capexsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexDto>;
    }),
  );
}

capexsCopyCreate.PATH = '/capexs/copy/{id}/';
